import { memo } from 'react'
import cn from 'classnames'

import { Icon } from '~/shared/ui/Icon'
import { Text } from '~/shared/ui/Text'

import { TAG_ICON_SIZE } from './config'
import type { TagProps } from './types'

import styles from './Tag.module.scss'

/** Как Badge, но радиус чипа и опциональная иконка слева. */
export const Tag = memo(function Tag(props: TagProps) {
  const { theme = 'NEUTRAL', size = 'M', isSolid = false, iconName, text } = props

  return (
    <span
      className={cn(
        styles.root,
        styles[`theme_${theme}`],
        styles[`size_${size}`],
        isSolid && styles.isSolid,
      )}
    >
      {iconName && <Icon name={iconName} size={TAG_ICON_SIZE[size]} strokeWidth={1.6} />}
      <Text variant={size === 'S' ? 'MICRO' : 'CAPTION'} color='INHERIT'>
        {text}
      </Text>
    </span>
  )
})
